// nodejs 请求自动添加 headers: {'x-use-ppe': '1', 'x-tt-env': 'ppe_dev'}
// 本地配合package.json的运行命令 推送到对应的测试环境会自动获取对应环境变量 只有匹配到的url才会自动添加
export default [
  '/motor/pc/content/home_video',
  '/motor/pc/content/pgc_content_rank',
  '/motor/pc/content/all_category_list',
  '/motor/pc/common/home_live_rooms',
  '/motor/pc/common/live_tabs',
  '/motor/pc/common/rcm_articles',
  '/motor/stream_entrance/get_feed',
  '/motor/pc/content/get_column_by_category', // 节目频道节目列表
  '/motor/pc/content/column/info/head', // 节目详情头部
  '/motor/pc/car/series/car_360_color_pic',
  '/motor/pc/car/series/home/head',
  '/motor/pc/car/series/car_eval_info',
  '/motor/pc/car/series/car_list',
  '/motor/pc/car/series/recommend_card',
  '/motor/pc/content/series_news',
  '/motor/pc/car/series/relation_brand_hot_series',
  '/motor/pc/ugc/series/buy_car',
  '/motor/searchapi/search_content', // 搜索
  '/motor/pc/car/search_sells_rank', // 搜索相关
  '/motor/pc/common/rank/hot_search', // 搜索相关
  '/motor/pc/common/rank/hot_column', // 搜索相关
  '/motor/searchapi/empty_page', // 搜索相关
  '/motor/pc/user/profile/user_info', // 个人页头部信息
  '/motor/pc/user/fans/user/list', // 个人页粉丝列表
  '/motor/pc/user/focus/user/list', // 个人页关注用户列表
  '/motor/pc/user/focus/car/list', // 个人页关注车系列表
  '/motor/pc/user/focus/cheyou/list', // 个人页关注车友圈列表
  '/motor/pc/user/profile/article', // 个人页文章
  '/motor/pc/user/profile/pgc_video', // 个人页视频
  '/motor/pc/user/profile/thread_video', // 个人页小视频
  '/motor/pc/user/profile/koubei', // 个人页口碑
  '/motor/pc/user/profile/comment', // 个人页评论
  '/motor/pc/user/profile/wenda', // 个人页问答
  '/motor/pc/user/profile/like', // 个人页喜欢
]
